<template>
  <div class="main-content-container task-dashboard-page">
    <div class="top-content-container">
      <b-row>
        <b-col>
          <b-breadcrumb class="customer-breadcrumbs pb-0">
            <b-breadcrumb-item>
              <span
                @click="$router.push({ name: 'TaskDashboard' })"
                class="font-family-regular"
              >
                Tasks
              </span>
            </b-breadcrumb-item>
            <b-breadcrumb-item active>
              <span class="font-family-regular">
                Task Dashboard
              </span>
            </b-breadcrumb-item>
          </b-breadcrumb>
          <ValidationObserver ref="dates">
            <div class="title-wrapper">
              <div class="title-h1-wrapper">
                <h1 class="font-lg primary-dark font-family-medium content-title">
                  Task Dashboard
                </h1>
              </div>
              <div class="filters-wrapper">
                <!-- Hiding the timer filter for now -->
                <div class="filter-wrapper" v-show="false">
                  <div class="filter-heading">Filter By</div>
                  <div class="datepicker-wrapper">
                    <ValidationProvider
                      rules=""
                    >
                      <b-input-group>
                        <b-form-select
                          class=""
                          :disabled="disableFilters"
                          placeholder="Select Filter"
                          autocomplete="off"
                          @change="fetchlist"
                          :options="timerFilterOptions"
                          v-model="timerFilter"
                        ></b-form-select>
                      </b-input-group>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="filter-wrapper">
                  <div class="filter-heading">From</div>
                  <div class="datepicker-wrapper">
                    <ValidationProvider
                      rules="dateForm|dateDifference:@confirm"
                      name="start Date"
                      v-slot="{ errors }"
                    >
                      <b-input-group>
                        <b-form-input
                          class=""
                          placeholder="Select date"
                          autocomplete="off"
                          :disabled="disableFilters"
                          @input="fetchlist"
                          v-model="dateFilter.from"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            button-only
                            :max="dateFilter.to"
                            right
                            :disabled="disableFilters"
                            :show-decade-nav="true"
                            class="datepicker"
                            locale="en-US"
                            v-model="dateFilter.from"
                            @input="fetchlist"
                          >
                            <template #button-content="">
                              <img
                                src="@/assets/icons/date-picker.svg"
                                alt=""
                              />
                            </template>
                          </b-form-datepicker>
                        </b-input-group-append>
                      </b-input-group>
                      <h6
                        v-if="errors[0]"
                        style="width:18rem"
                        class="font-sm font-family-regular position-relative danger"
                      >
                        {{ errors[0] }}
                      </h6>
                    </ValidationProvider>
                  </div>
                </div>
                <div class="filter-wrapper">
                  <div class="filter-heading">To</div>
                  <div class="datepicker-wrapper">
                    <ValidationProvider
                      name="confirm"
                      rules="dateForm"
                      v-slot="{ errors }"
                    >
                      <b-input-group>
                        <b-form-input
                          class=""
                          placeholder="Select date"
                          autocomplete="off"
                          @input="fetchlist"
                          :disabled="disableFilters"
                          v-model="dateFilter.to"
                        ></b-form-input>
                        <b-input-group-append>
                          <b-form-datepicker
                            button-only
                            :disabled="disableFilters"
                            right
                            :show-decade-nav="true"
                            class="datepicker"
                            :min="dateFilter.from"
                            locale="en-US"
                            v-model="dateFilter.to"
                            @input="fetchlist"
                          >
                            <template #button-content="">
                              <img
                                src="@/assets/icons/date-picker.svg"
                                alt=""
                              />
                            </template>
                          </b-form-datepicker>
                        </b-input-group-append>
                      </b-input-group>
                      <h6
                        v-if="errors[0]"
                        style="width:18rem"
                        class="font-sm font-family-regular position-relative danger"
                      >
                        {{ errors[0] }}
                      </h6>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </ValidationObserver>
          <b-dropdown-divider class="position-relative mt-0 " />
        </b-col>
      </b-row>
    </div>
    <!-- Start task dashboard cards -->
    <b-row
      v-if="statusLoaded"
      class="position-relative task-dashboard-row"
      ref="taskDashboardRow"
    >
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': dailyTasks.length,
            'empty-task-cards-wrapper': !dailyTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center mb-2">
            <img src="@/assets/icons/circle_new_task.svg" alt="" />
            <h6
              class="font-sm secondary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listOneTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :filters="currentFilters" 
              :cardCount="dailyTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[0]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              @touchend="fixDragAndDropMobile"
              :get-child-payload="getChildPayloadOne"
              group-name="1"
              drag-class="card-ghost"
              class="container daily-container"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('dailyTasks', $event)"
              @drag-start="dragListener"
              @drag-end="dragListener"
            >
              <Draggable v-for="item in dailyTasks" :key="item.id">
                <TaskCards
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :list="dailyTasks"
                  :isLoadingList="isLoadingList"
                  :shouldPatch="shouldPatch"
                  @card-moved="onCardMoved"
                  v-on:updateQueue="reloadQueues"
                  :positionInfo="getPositionInfo(dailyTasks, item)"
                  :status="statusIdOne"
                  :statusTitle="listOneTitle"
                  :profileId="profileId"
                  :trackerID="item.lastTracker.id"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                :identifier="dailyInfiniteId"
                force-use-infinite-wrapper=".daily-container"
                @infinite="infiniteHandlerDaily"
              >
                <div slot="no-more">
                  <p class="mt-3">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[dailyTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdOne, true)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="cards-container">
        <b-card
          class=" px-2 py-2"
          :class="{
            'task-cards-wrapper': todoTasks.length,
            'empty-task-cards-wrapper': !todoTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center mb-2">
            <img src="@/assets/icons/circle_today.svg" alt="" />
            <h6
              class="font-sm secondary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listTwoTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :filters="currentFilters" 
              @bulk-action="onBulkAction"
              :cardCount="todoTasks.length"
              :queueStatus="statuses[1]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="" data-cy="cy-todo-cards">
            <!-- {{ offsetTodo }}{{ todoTasks.length }} -->
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :get-child-payload="getChildPayloadTwo"
              group-name="1"
              class="container todo-container"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('todoTasks', $event)"
            >
              <Draggable v-for="item in todoTasks" :key="item.id">
                <TaskCards
                  :isLoadingList="isLoadingList"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  :list="todoTasks"
                  :shouldPatch="shouldPatch"
                  @card-moved="onCardMoved"
                  v-on:updateQueue="reloadQueues"
                  :positionInfo="getPositionInfo(todoTasks, item)"
                  :status="statusIdTwo"
                  :statusTitle="listTwoTitle"
                  :profileId="profileId"
                  :trackerID="item.lastTracker.id"
                  :priority="item.priority === 'high' ? true : false"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                @infinite="infiniteHandlerTodo"
                :identifier="todoInfiniteId"
                spinner="spiral"
                force-use-infinite-wrapper=".todo-container"
              >
                <div slot="no-more">
                  <p class="mt-3">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[todoTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdTwo, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="cards-container">
        <b-card
          class=" px-2 py-2"
          :class="{
            'task-cards-wrapper': laterTasks.length,
            'empty-task-cards-wrapper': !laterTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center mb-2">
            <img src="@/assets/icons/circle_later.svg" alt="" />
            <h6
              class="font-sm secondary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listThreeTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :filters="currentFilters" 
              @bulk-action="onBulkAction"
              :queueStatus="statuses[2]"
              :cardCount="laterTasks.length"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :get-child-payload="getChildPayloadThree"
              class="container later-container"
              group-name="1"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('laterTasks', $event)"
            >
              <Draggable v-for="item in laterTasks" :key="item.id">
                <TaskCards
                  :priority="item.priority === 'high' ? true : false"
                  :isLoadingList="isLoadingList"
                  :cardData="item"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  @card-moved="onCardMoved"
                  :list="laterTasks"
                  :shouldPatch="shouldPatch"
                  :status="statusIdThree"
                  v-on:updateQueue="reloadQueues"
                  :positionInfo="getPositionInfo(laterTasks, item)"
                  :statusTitle="listThreeTitle"
                  :profileId="profileId"
                  :trackerID="item.lastTracker.id"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                :identifier="laterInfiniteId"
                force-use-infinite-wrapper=".later-container"
                @infinite="infiniteHandlerLater"
                ><div slot="no-more">
                  <p class="mt-3">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[laterTasks.length === 0 ? 'add-another-task-btn' : null]"
          >
            <h6
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdThree, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': inProgressTasks.length,
            'empty-task-cards-wrapper': !inProgressTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center mb-2">
            <img src="@/assets/icons/circle_in_progress.svg" alt="" />
            <h6
              class="font-sm secondary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listFourTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :filters="currentFilters" 
              @bulk-action="onBulkAction"
              :cardCount="inProgressTasks.length"
              :queueStatus="statuses[3]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              @touchend="fixDragAndDropMobile"
              :get-child-payload="getChildPayloadFour"
              class="container inprogress-container"
              drag-class="card-ghost"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              group-name="1"
              @drop="onDrop('inProgressTasks', $event)"
            >
              <Draggable v-for="item in inProgressTasks" :key="item.id">
                <TaskCards
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  :isLoadingList="isLoadingList"
                  :list="inProgressTasks"
                  @card-moved="onCardMoved"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  v-on:updateQueue="reloadQueues"
                  :positionInfo="getPositionInfo(inProgressTasks, item)"
                  :shouldPatch="shouldPatch"
                  :status="statusIdFour"
                  :statusTitle="listFourTitle"
                  :profileId="profileId"
                  :trackerID="item.lastTracker.id"
                  :time="getMoment(item)"
                  :paused="
                    item.lastTracker.startAt === null
                      ? true
                      : item.lastTracker.stopAt !== null
                      ? true
                      : false
                  "
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                :identifier="inProgressInfiniteId"
                force-use-infinite-wrapper=".inprogress-container"
                @infinite="infiniteHandlerInProgress"
              >
                <div slot="no-more">
                  <p class="mt-3">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <div
            class="d-flex ml-3"
            :class="[
              inProgressTasks.length === 0 ? 'add-another-task-btn' : null
            ]"
          >
            <h6
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdFour, false)"
            >
              + Add another task
            </h6>
          </div>
        </b-card>
      </b-col>
      <b-col md="4" xl="3" lg="5" sm="6" cols="10" class="cards-container">
        <b-card
          class="px-2 py-2"
          :class="{
            'task-cards-wrapper': completedTasks.length,
            'empty-task-cards-wrapper': !completedTasks.length
          }"
          no-body
        >
          <div class="d-flex align-items-center mb-2">
            <img src="@/assets/icons/circle_complete.svg" alt="" />
            <h6
              class="font-sm secondary--text font-family-regular ml-3 position-relative list-titles"
            >
              {{ listFiveTitle }}
            </h6>
            <bulk-actions-dropdown 
              :statuses="statuses"
              :filters="currentFilters" 
              :cardCount="completedTasks.length"
              @bulk-action="onBulkAction"
              :queueStatus="statuses[4]"
              :assistants="assistants"
            />
          </div>
          <div @touchend="fixDragAndDropMobile" style="">
            <Container
              @touchend="fixDragAndDropMobile"
              :get-child-payload="getChildPayloadFive"
              group-name="1"
              drag-class="card-ghost"
              class="container completed-container"
              drop-class="card-ghost-drop"
              :drop-placeholder="dropPlaceholderOptions"
              @drop="onDrop('completedTasks', $event)"
            >
              <Draggable v-for="item in completedTasks" :key="item.id">
                <TaskCards
                  :priority="item.priority === 'high' ? true : false"
                  :cardData="item"
                  :list="completedTasks"
                  @card-moved="onCardMoved"
                  :isLoadingList="isLoadingList"
                  :shouldPatch="shouldPatch"
                  @z-click="onCardClick"
                  @z-dblclick="onCardDoubleClick"
                  :navigateOnClick="false"
                  v-on:updateQueue="reloadQueues"
                  :positionInfo="getPositionInfo(completedTasks, item)"
                  :status="statusIdFive"
                  :statusTitle="listFiveTitle"
                  :profileId="profileId"
                  :trackerID="item.lastTracker.id"
                  :time="getMoment(item)"
                  :paused="true"
                />
              </Draggable>
              <infinite-loading
                spinner="spiral"
                :identifier="completedInfiniteId"
                force-use-infinite-wrapper=".completed-container"
                @infinite="infiniteHandlerCompleted"
              >
                <div slot="no-more">
                  <p class="mt-3">No more tasks to load</p>
                </div>
                <div slot="no-results">
                  <p class="mt-3">
                    No more tasks to load
                  </p>
                </div></infinite-loading
              >
            </Container>
          </div>
          <!-- <div
            class="d-flex ml-3"
            :class="[
              completedTasks.length === 0 ? 'add-another-task-btn' : null
            ]"
          >
            <h6
              class="font-sm mt-3 cursor-pointer primary--text font-family-regular text-underline add-another-task"
              @click="navigate(statusIdFive, false)"
            >
              + Add another task
            </h6>
          </div> -->
        </b-card>
      </b-col>
    </b-row>
    <!-- <div
      class="no-assigned-msg position-absolute d-flex flex-column justify-content-center align-items-center"
    >
      <h4 class="primary--text font-family-medium" style="margin-top:10rem" v-if="showEmptyTasksMsg">
        No tasks created yet.
      </h4>
    </div> -->
    <b-modal
      centered
      class="modal-padding"
      hide-footer
      v-model="showAuthError"
      hide-header
      no-close-on-backdrop
      no-close-on-esc
    >
      <b-container fluid>
        <b-button class="d-flex position-absolute close-btn">
          <img class="close-icon" src="@/assets/icons/close_sidebar.svg" alt />
        </b-button>
      </b-container>
    </b-modal>
    <view-task-modal
      v-model="viewTaskModal.visible"
      @task-deleted="onTaskDeleted"
      @task-archived="onTaskArchived"
      :taskId="viewTaskModal.taskId"
      :queueName="viewTaskModal.queueName"
      @task-handover="reloadAllQueues"
      @timer-started="reloadAllQueues"
      @timer-stopped="reloadAllQueues"
      @status-updated="reloadAllQueues"
      @navigate="onNavigate"
      @priority-changed="onPriorityChanged"
    />
    <!-- End -->
    <b-avatar
      data-cy="task-add-btn"
      button
      @click="navigate(statusIdTwo, false)"
      size="4.8rem"
      class="floating-action-btn mb-5 position-fixed cursor-pointer"
    >
      <img src="@/assets/icons/floating_plus.svg" alt="" />
    </b-avatar>
  </div>
</template>

<script>
import TaskCards from "@/components/taskcardsComponent/TaskCards.vue";
import { applyDrag } from "@/utils/applyDrag";
import { Container, Draggable } from "vue-smooth-dnd";
import { mapActions, mapState } from "vuex";
import { patchTaskBoard } from "@/apis/common";
import { getNewPosition } from "@/utils/utils";
import ViewTaskModal from "@/views/common/ViewTaskModal"
import ScrollPanner from "@/utils/ScrollPanner.js";
import moment from "moment";
import {
  ValidationProvider,
  ValidationObserver,
  extend
} from "vee-validate/dist/vee-validate.full";
import {
  getAdminTaskBoard,
  getPATaskBoard,
  getTaskStatus
} from "@/apis/common";
import { getAssistantsList } from '@/apis/assistants'
import BulkActionsDropdown from "@/components/dropdowns/BulkActionsDropdown.vue";
let dateMessage = "YYYY-MM-DD format is required";

function isEmpty(value) {
  return value === null || value === undefined || value === ''
}

extend("dateForm", {
  message: () => dateMessage,
  validate: value => {
    let mustContainTheseChars = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;
    let containsRequiredChars = mustContainTheseChars.test(value);
    if (containsRequiredChars) {
      return true;
    } else {
      return false;
    }
  }
});
extend("dateDifference", {
  params: ["target"],
  validate(value, { target }) {
    if (target && target.length > 0 && value <= target) {
      return true;
    } else if (target && target.length > 0 && value > target) {
      return false;
    }
  },
  message: "Start date cannot be greater than end date"
});
export default {
  name: "TaskDashboard",
  components: {
    TaskCards,
    Draggable,
    Container,
    ValidationObserver,
    ValidationProvider,
    ViewTaskModal,
    BulkActionsDropdown
  },
  computed: {
    ...mapState("authModule", ["profileUserId"]),
    filtersActive() {
      let { from, to } = this.dateFilter
      const datesEmpty = isEmpty(from) && isEmpty(to)
      return !datesEmpty || this.timerFilter !== null
    },
    currentFilters() {
      return {
        created_gte: this.dateFilter.from,
        created_lte: this.dateFilter.to,
        is_timer_running: this.timerFilter
      }
    },
    showEmptyTasksMsg() {
      return (
        !this.isLoadingList &&
        this.todoTasks.length === 0 &&
        this.laterTasks.length === 0 &&
        this.inProgressTasks.length === 0 &&
        this.completedTasks.length === 0
      );
    },
    disableFilters() {
      return this.loading
    },
    loading() {
      return [
        this.reloadingDaily,
        this.reloadingTodo,
        this.reloadingInProgress,
        this.reloadingLater,
        this.reloadingCompleted
      ].some(flag => flag)
    }
  },
  data() {
    return {
      profileId: "",
      role: "",
      assistants: [],
      allTasks: [],
      showAuthError: false,
      viewTaskModal: {
        visible: false,
        taskId: '',
        queueName: ""
      },
      listTitles: [],
      statusIds: [],
      statuses: [],
      listOneTitle: "",
      listTwoTitle: "",
      listThreeTitle: "",
      listFourTitle: "",
      listFiveTitle: "",
      statusIdOne: "",
      statusIdTwo: "",
      statusIdThree: "",
      statusIdFour: "",
      statusIdFive: "",
      limit: 20,
      offsetTodo: 0,
      offsetLater: 0,
      offsetInProgress: 0,
      offsetCompleted: 0,
      offsetDaily: 0,
      dropPlaceholderOptions: {
        className: "drop-preview",
        animationDuration: "150",
        showOnTop: false
      },
      unAssignedTasks: [],
      reloadingTodo: false,
      reloadingLater: false,
      reloadingInProgress: false,
      reloadingCompleted: false,
      reloadingDaily: false,
      todoTasks: [],
      laterTasks: [],
      inProgressTasks: [],
      completedTasks: [],
      dailyTasks: [],
      shouldPatch: false,
      isLoadingList: true,
      count: null,
      statusLoaded: false,
      dateFilter: {
        from: null,
        to: null
      },
      timerFilter: null,
      timerFilterOptions: [
        { value: null, text: 'Timer status' },
        { value: true, text: 'Timer on' },
        { value: false, text: 'Timer off' }
      ],
      todoInfiniteId: +new Date(),
      dailyInfiniteId: new Date() * 2,
      laterInfiniteId: new Date() * 3,
      inProgressInfiniteId: new Date() * 4,
      completedInfiniteId: new Date() * 5
    };
  },
  created() {
    this.actionGetUserDetails()
      .then(res => {
        this.role = res.role;
        this.profileId = res.defaultProfile.id;
        getTaskStatus().then(res => {
          this.statuses = res.data.results.sort(
            (a, b) => a.position - b.position
          );
          this.statusIdOne = this.statuses[0].id;
          this.statusIdTwo = this.statuses[1].id;
          this.statusIdThree = this.statuses[2].id;
          this.statusIdFour = this.statuses[3].id;
          this.statusIdFive = this.statuses[4].id;
          this.listOneTitle = this.statuses[0].title;
          this.listTwoTitle = this.statuses[1].title;
          this.listThreeTitle = this.statuses[2].title;
          this.listFourTitle = this.statuses[3].title;
          this.listFiveTitle = this.statuses[4].title;
          this.statusLoaded = true;
          this.$nextTick(() => {
            new ScrollPanner().initialize(this);
          });
        });
      })
      .catch(err => {
        console.log(err);
      });
    this.loadAssistants();
    this.trackView();
  },
  methods: {
    dragListener() {
      // this dummy function is apparently necessary because without it the drag-start and
      // drag-end events don't fire
    },
    trackView() {
      this.$gtag.event("Taskboard - View", {
        event_category: "feature"
      });
    },
    trackAddTask() {
      this.$gtag.event("Taskboard - Add Task", {
        event_category: "feature"
      });
    },
    trackOpenTaskCard() {
      this.$gtag.event("Taskboard - Open Task Card", {
        event_category: "feature"
      });
    },
    trackOpenTaskPage() {
      this.$gtag.event("Taskboard - Open Task Page", {
        event_category: "feature"
      });
    },
    onCardClick(card) {
      this.trackOpenTaskCard();
      this.viewTaskModal.taskId = card.cardData.id;
      this.viewTaskModal.visible = true;
      this.viewTaskModal.queueName = card.statusTitle;
    },
    onCardDoubleClick(card) {
      this.trackOpenTaskPage();
      this.$router.push({
        name: "ViewTask",
        params: {
          id: card.cardData.id
        }
      })
    },
    onBulkAction() {
      this.reloadAllQueues()
    },
    async loadAssistants() {
      // assistants are needed to display them in the handover bulk actions modal
      try {
          let apiResponse = await getAssistantsList()
          this.assistants = apiResponse.data.results
        } catch(e) {
          console.log(e)
        }
    },
    getPositionInfo(tasks, item) {
      let { id } = item;
      let cardIndex = tasks.findIndex(card => card.id === id);
      const isFirstCard = cardIndex === 0;
      const isLastCard = cardIndex === tasks.length - 1;
      return {
        position: item.position,
        previousPosition: isFirstCard ? null : tasks[cardIndex - 1].position,
        nextPosition: isLastCard ? null : tasks[cardIndex + 1].position,
        isHandover: item.isHandover
      };
    },
    generateId(index) {
      return (
        "_" +
        Math.random()
          .toString(36)
          .substr(2, 9) +
        index
      );
    },
    validateDates() {
      // doing manual date validation because automatic date validation is buggy
      const { from, to } = this.dateFilter
      let regex = /^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/;

      this.$refs.dates.validate() // show the error messages if any

      const datesAreEmpty = isEmpty(from) && isEmpty(to)
      if (datesAreEmpty) return true;

      const datesValid = regex.test(from) && regex.test(to)
      if (!datesValid) return false;

      let _from = moment(from, "YYYY-MM-DD");
      let _to = moment(to, "YYYY-MM-DD");

      // no dates is a valid filter
      // if dates are applied, then both have to be filled and valid
      let isValid = _from.isSameOrBefore(_to)
      return isValid
    },
    async fetchlist() {
      let isValid = this.validateDates()
      if (isValid) {
        this.reloadAllQueues()
        // this.dailyTasks = [];
        // this.todoTasks = [];
        // this.laterTasks = [];
        // this.inProgressTasks = [];
        // this.completedTasks = [];
      }
    },
    reloadDaily() {
      this.dailyTasks = [];
      this.offsetDaily = 0;
      this.reloadingDaily = true;
      this.dailyInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadTodo() {
      this.todoTasks = [];
      this.offsetTodo = 0;
      this.reloadingTodo = true;
      this.todoInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadLater() {
      this.laterTasks = [];
      this.offsetLater = 0;
      this.reloadingLater = true;
      this.laterInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadInProgress() {
      this.inProgressTasks = [];
      this.offsetInProgress = 0;
      this.reloadingInProgress = true;
      this.inProgressInfiniteId += 1;
      this.shouldPatch = false;
    },
    reloadCompleted() {
      this.completedTasks = [];
      this.offsetCompleted = 0;
      this.reloadingCompleted = true;
      this.completedInfiniteId += 1;
      this.shouldPatch = false;
    },
    onPriorityChanged(data) {
      this.reloadQueues(null, this.getQueueIndex(data), true);
    },
    reloadQueues(fromIndex, toIndex, updateSource) {
      let reloadArray = [
        this.reloadDaily,
        this.reloadTodo,
        this.reloadLater,
        this.reloadInProgress,
        this.reloadCompleted
      ];
      let taskArrays = [
        this.dailyTasks,
        this.todoTasks,
        this.laterTasks,
        this.inProgressTasks,
        this.completedTasks
      ];
      if (
        taskArrays[fromIndex] &&
        taskArrays[fromIndex].length < 3 &&
        updateSource
      ) {
        reloadArray[fromIndex]();
      }
      reloadArray[toIndex]();
    },
    reloadAllQueues() {
      // this.dailyTasks = [];
      // this.todoTasks = [];
      // this.laterTasks = [];
      // this.inProgressTasks = [];
      // this.completedTasks = [];

      this.reloadDaily();
      this.reloadTodo();
      this.reloadLater();
      this.reloadInProgress();
      this.reloadCompleted();
    },
    getQueueIndex(queueName) {
      switch (queueName) {
        case "Daily":
          return 0;
        case "Today":
          return 1;
        case "Later":
          return 2;
        case "In Progress":
          return 3;
        default:
          return 0;
      }
    },
    infiniteHandlerDaily($state) {
      let getDailyBoard = null;
      if (this.role === "assistant") {
        getDailyBoard = getPATaskBoard;
      } else {
        getDailyBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[0].id,
        limit: this.limit,
        is_archive: false,
        offset: this.offsetDaily,
        is_timer_running: this.timerFilter,
        created_gte: this.dateFilter.from,
        created_lte: this.dateFilter.to
      }
      getDailyBoard(
        this.profileId,
        params
      )
        .then(res => {

          if (this.reloadingDaily) {
            this.dailyTasks = [...res.data.results];
            this.reloadingDaily = false;
          } else {
            this.dailyTasks = [...this.dailyTasks, ...res.data.results];
          }
          this.offsetDaily = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
      // $event.loaded();
    },
    infiniteHandlerTodo($state) {
      let getTodoBoard = null;
      if (this.role === "assistant") {
        getTodoBoard = getPATaskBoard;
      } else {
        getTodoBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[1].id,
        limit: this.limit,
        is_archive: false,
        offset: this.offsetTodo,
        is_timer_running: this.timerFilter,
        created_gte: this.dateFilter.from,
        created_lte: this.dateFilter.to
      }
      getTodoBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloadingTodo) {
            this.todoTasks = [...res.data.results];
            this.reloadingTodo = false;
          } else {
            this.todoTasks = [...this.todoTasks, ...res.data.results];
          }
          this.offsetTodo = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
      // $event.loaded();
    },
    infiniteHandlerLater($state) {
      let getLaterBoard = null;
      if (this.role === "assistant") {
        getLaterBoard = getPATaskBoard;
      } else {
        getLaterBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[2].id,
        limit: this.limit,
        is_archive: false,
        offset: this.offsetLater,
        is_timer_running: this.timerFilter,
        created_gte: this.dateFilter.from,
        created_lte: this.dateFilter.to
      }
      getLaterBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloadingLater) {
            this.laterTasks = [...res.data.results];
            this.reloadingLater = false;
          } else {
            this.laterTasks = [...this.laterTasks, ...res.data.results];
          }
          this.offsetLater = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerInProgress($state) {
      let getInProgressBoard = null;
      if (this.role === "assistant") {
        getInProgressBoard = getPATaskBoard;
      } else {
        getInProgressBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[3].id,
        limit: this.limit,
        offset: this.offsetInProgress,
        is_archive: false,
        is_timer_running: this.timerFilter,
        created_gte: this.dateFilter.from,
        created_lte: this.dateFilter.to
      }
      getInProgressBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloadingInProgress) {
            this.inProgressTasks = [...res.data.results];
            this.reloadingInProgress = false;
          } else {
            this.inProgressTasks = [
              ...this.inProgressTasks,
              ...res.data.results
            ];
          }
          this.offsetInProgress = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    infiniteHandlerCompleted($state) {
      let getCompletedBoard = null;
      if (this.role === "assistant") {
        getCompletedBoard = getPATaskBoard;
      } else {
        getCompletedBoard = getAdminTaskBoard;
      }
      let params = {
        status: this.statuses[4].id,
        limit: this.limit,
        is_archive: false,
        offset: this.offsetCompleted,
        is_timer_running: this.timerFilter,
        created_gte: this.dateFilter.from,
        created_lte: this.dateFilter.to
      }
      getCompletedBoard(
        this.profileId,
        params
      )
        .then(res => {
          if (this.reloadingCompleted) {
            this.completedTasks = [...res.data.results];
            this.reloadingCompleted = false;
          } else {
            this.completedTasks = [...this.completedTasks, ...res.data.results];
          }
          this.offsetCompleted = res.data.offset;
          if (res.data.next === null) {
            $state.complete();
          } else {
            $state.loaded();
          }
        })
        .catch(err => {
          console.log(err);
          this.isLoadingList = false;
        })
        .finally(() => {
          this.isLoadingList = false;
        });
    },
    ...mapActions("authModule", ["actionGetUserDetails"]),
    navigate(id, frequency) {
      this.trackAddTask();
      this.$router.push({
        name: "AddTask",
        params: {
          statusID: id,
          frequency: frequency
        }
      });
    },
    fixDragAndDropMobile() {
      // Fixes drag and drop not working in mobile
      document.body.classList.remove(
        "smooth-dnd-no-user-select",
        "smooth-dnd-disable-touch-action"
      );
      return true;
    },
    onDrop(collection, dropResult) {
      this.shouldPatch = true;
      this[collection] = applyDrag(this[collection], dropResult);

      let { addedIndex, removedIndex } = dropResult;
      let card = dropResult.payload;

      // intra queue move occured
      if (addedIndex !== null && removedIndex !== null) {
        // there's no need to update the position of the card if it has been
        // picked up and dropped in the same place
        if (addedIndex !== removedIndex) {
          this.updateCardPosition(card, collection);
        }
      }
    },
    async updateCardPosition(card, collection) {
      let positionInfo = this.getPositionInfo(this[collection], card);
      let data = {
        position: getNewPosition(positionInfo)
      };
      try {
        let res = await patchTaskBoard(card.id, data);
        card.position = res.data.position;
        if (res.data.isPositionReset) {
          this.reloadAllQueues();
        }
      } catch (e) {
        console.log(e);
      }
    },
    getChildPayloadOne(index) {
      return this.dailyTasks[index];
    },
    getChildPayloadTwo(index) {
      return this.todoTasks[index];
    },
    getChildPayloadThree(index) {
      return this.laterTasks[index];
    },
    getChildPayloadFour(index) {
      return this.inProgressTasks[index];
    },
    getChildPayloadFive(index) {
      return this.completedTasks[index];
    },
    getMoment: item => {
      if (item.lastTracker.startAt === null) {
        return 0;
      } else if (item.lastTracker.stopAt === null) {
        let duration = moment()
          .utc()
          .diff(item.lastTracker.startAt, "seconds");
        duration += item.trackersLog.timeSpent;
        return duration;
      } else {
        let duration = item.trackersLog.timeSpent;
        return duration;
      }
    },
    onTaskDeleted() {
      this.reloadAllQueues()
    },
    onTaskArchived() {
      this.reloadAllQueues();
    },
    onNavigate() {
      this.viewTaskModal.visible = false
    },
    async onCardMoved(card) {
      // inter queue move occured
      let newPosition = getNewPosition(card.positionInfo);
      let payload = {
        status: card.status,
        position: newPosition,
        completedDate:
          card.statusTitle === "Complete"
            ? moment()
                .utc()
                .format("YYYY-MM-DD")
            : null
      };
      let cardId = card.cardData.id;
      try {
        let res = await patchTaskBoard(cardId, payload);
        const statusIds = [
          this.statusIdOne,
          this.statusIdTwo,
          this.statusIdThree,
          this.statusIdFour,
          this.statusIdFive,
        ]
        let toIndex = statusIds.findIndex(
          status => res.data.status.id === status
        );
        let fromIndex = statusIds.findIndex(
          status => card.cardData.status.id === status
        );
        // keep the reactive properites in sync with the API data
        let cardInfoObject = card.list.find(card => card.id === cardId);
        cardInfoObject.status = res.data.status;
        cardInfoObject.position = res.data.position;
        // reload the queues
        if (res.data.isPositionReset) {
          this.reloadAllQueues();
        } else {
          this.reloadQueues(fromIndex, toIndex, true);
        }
      } catch (e) {
        console.log(e);
        // e.g. the completed-task lock window has closed - the card already
        // moved visually via onDrop, so reload to snap it back to the real
        // server state. Same toast treatment as the 2-running-timers cap.
        this.$bvToast.toast(
          e.response?.data?.detail || "Unable to move this task.",
          {
            title: "⚠ Task",
            variant: "danger",
            solid: true,
            autoHideDelay: 8000,
            toaster: "b-toaster-top-center",
            toastClass: "hr-toast-alert"
          }
        );
        this.reloadAllQueues();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/scss/variables/colors.scss";

.main-content-container {
  display: flex;
  flex-direction: column;
}
.content-title {
  margin-bottom: 0;
}
// .top-content-container {
//   // height: 25%;
//   flex: 1;
// }
.cards-container {
  height: 100%;
  padding: 10px;
  max-width: 270px;
}
.floating-action-btn {
  right: 3rem;
  z-index: 2;
  bottom: 0;
}
.no-assigned-msg {
  width: 95%;
  top: 75%;
}

.empty-icon-avatar {
  width: 2.4rem;
  height: 2.4rem;
  border-radius: 50% !important;
  cursor: pointer;
}
.container {
  padding: 0rem;
}
.empty-container {
  height: auto;
}
h6 {
  margin-bottom: 0rem;
}
ol.breadcrumb.customer-breadcrumbs.pb-2 {
  // line-height: 0;
}
.task-dashboard-row {
  // height: 75%;
  flex: 3;
  padding-left: 5px;
  padding-bottom: 10px;
  padding-top: 5px;
}
.add-another-task {
  margin-top: 0rem !important;
  margin-bottom: 0rem;
}
.first-column {
  // padding-left : 0;
}
.title-wrapper {
  display: flex;
  padding-bottom: 15px;
  .title-h1-wrapper {
    h1 {
      position: relative;
      top: 2rem;
    }
  }
  .filters-wrapper {
    margin-left: auto;
    display: flex;
    .filter-wrapper {
      margin-left: auto;
    }
    .filter-wrapper:nth-child(2),
    .filter-wrapper:nth-child(3),
    .filter-wrapper:nth-child(4) {
      padding-left: 2rem;
    }
    .filter-heading {
      font-size: 1.5rem;
      color: #8098a4;
    }
    .datepicker-wrapper {
      .form-control:disabled {
        background-color: white;
      }
    }
  }
}
div.card.task-cards-wrapper {
  max-height: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  > div:nth-child(1) {
    // status title: Today, Later, etc
    flex: 0 0 auto;
  }
  > div:nth-child(2) {
    // scrollable container for cards
    flex: 1 1 auto;
    display: flex;
    min-height: 0;
  }
  > div:nth-child(3) {
    // + Add another task
    height: 10%;
  }
}
.smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
  overflow: unset;
}
.smooth-dnd-container {
  display: flex;
  flex-direction: column;
}
.task-running {
  order: 0 !important;
}
.smooth-dnd-draggable-wrapper,
.task-paused {
  order: 1;
}
.infinite-loading-container {
  order: 2;
}
</style>
